export const environment = {
  production: true,
  baseURL: 'https://admin.eu.prod.theloops.ai/v1',
  cubejsURL: 'https://admin.eu.prod.theloops.ai/cubejs-api/v1',
  /** Cube.js JWT for analytics API (from /teams/authorize) */
  appId: '2',
  envName: 'euprod',
    /** Base URL for this app (Teams tab contentUrl/websiteUrl); used when building for each env */
  agentHomepageBaseUrl: 'https://agenthomepage.eu.theloops.ai',
  reactAppBaseUrl: 'https://#tenantId#.eu.theloops.ai'
};
